export default {
  items: [
    {
      name: 'TEMPLATES',
      url: '/templates/list',
      svgIcon: 'templates'
    },
    {
      name: 'FORMS',
      url: '/process/processed',
      svgIcon: 'forms'
    },
    // {
    //   name: 'UPLOAD_FORM',
    //   url: '/process/upload',
    //   svgIcon: 'uploadScan'
    // },
    {
      name: 'REPORTS',
      url: '/reports/logs',
      svgIcon: 'reports'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js